import * as React from 'react';
import { DetailsCard } from 'nomst/Components/SharedJobCollab/detailsCard';
import './compFactorCard.scss';

interface CompFactorCardProps {
    className?: string;
    title?: string;
    selectOptions?: {[key: string]: string};
    items: Array<{
        factorName?: string,
        label: string,
        value: CompfactorValue,
        important?: boolean // whether the factor should be displayed prominently
    }>;
}

const CompFactorCard = (props: CompFactorCardProps): JSX.Element | null => {
    const { title, items, className } = props;
    let itemDivs: JSX.Element[] = [];
    if (items) {
        const seenItems: {[name: string]: boolean} = {};
        itemDivs = items.filter(item => {
            // filter to de-dup
            const unique = !seenItems[item.label];
            seenItems[item.label] = true;
            return unique;
        }).map(item => {
            let value = item.value;
            if (value && value instanceof Array) {
                value = value.join(', ');
            }

            const compFactorProps: DisplayCompFactorProps = {
                item,
                value
            };

            return <div key={item.label} className="comp-factor-item">
                <div className="comp-factor-label">
                    {item.label}
                </div>
                { DisplayCompFactor(compFactorProps) }
            </div>;
        });
    }

    if (itemDivs.length === 0) {
        return null;
    }

    return <DetailsCard title={title} className={`comp-factor ${className || ''}`}>
        <div className="comp-factor-items">
            {itemDivs}
        </div>
    </DetailsCard>;
};

interface DisplayCompFactorProps {
    value: CompfactorValue;
    item: {
        factorName?: string,
        label: string,
        important?: boolean // whether the factor should be displayed prominently
    };
}

const DisplayCompFactor = (props: DisplayCompFactorProps): JSX.Element => {
    const { item, value } = props;
    const className = item.important ? 'important' : '';
    return <div className={`comp-factor-value ${className}`}>
        {value}
    </div>;
};

export { CompFactorCard };
export default CompFactorCard;